import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import * as Yup from "yup";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { useHistory, useLocation } from "react-router";
import queryString from "query-string";
import { useDispatch } from "react-redux";
import { toAbsoluteUrl } from "../../../../Utils/_helpers";
import "@material/react-text-field/dist/text-field.css";
import "@rmwc/textfield/styles";
import { TextField } from "@rmwc/textfield";
import { APP_CONSTANT } from "../../../util/constants";

const initialValues = {
  password: "",
  confirm_password: "",
};

function ResetPassword(props) {
  const { intl } = props;
  const dispatch = useDispatch();

  const location = useLocation();
  const params = queryString.parse(location.search);

  const [loading, setLoading] = useState(false);
  const [isRequested, setIsRequested] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [confirmPasswordShown, setConfirmPasswordShown] = useState(true);
  var showPasswordIconUrl = toAbsoluteUrl("/media/sr/icons/eye_open.svg");
  var hidePasswordIconUrl = toAbsoluteUrl("/media/sr/icons/eye_close.svg");
  const ResetPasswordSchema = Yup.object().shape({
    password: Yup.string().required(
      intl.formatMessage({
        id: "Auth_validation-required-field",
      })
    ),
    confirm_password: Yup.string()
      .required(
        intl.formatMessage({
          id: "Auth_validation-required-field",
        })
      )
      .test("passwords-match", "Passwords must match", function(value) {
        return this.parent.password === value;
      }),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const history = useHistory();

  const handleSuccessMessage = (response) => {
    if (response.status === 200) {
      formik.setStatus({
        isSuccess: true,
        message: "Password successfully saved",
      });
      setTimeout(() => {
        history.push("/auth");
      }, 3000);
    } else {
      formik.setStatus({ isSuccess: false, message: response.error.message });
    }
  };

  const handleErrorMessage = (response) => {
    formik.setStatus({ isSuccess: false, message: response.error.message });
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const filledInputClass = (fieldname) => {
    if (formik.values[fieldname].length) {
      return "is-filled";
    }
    return "";
  };

  const toggelPasswordInput = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const toggelConfirmPasswordInput = () => {
    setConfirmPasswordShown(confirmPasswordShown ? false : true);
  };

  const formik = useFormik({
    initialValues,
    validateOnChange: true,
    validateOnBlur: true,
    validationSchema: ResetPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      dispatch(
        auth.actions.resetPassword(
          {
            password: values.password,
            confirm_password: values.confirm_password,
            uid: params.uid,
            token: params.token,
          },
          (response) => {
            handleSuccessMessage(response);
            setSubmitting(false);
            disableLoading();
          },
          (response) => {
            handleErrorMessage(response);
            setSubmitting(false);
            disableLoading();
          }
        )
      );
    },
  });

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="sr-login-form login-reset" style={{ display: "block" }}>
          <div className="d-none d-lg-block">
            <img
              alt=""
              src={toAbsoluteUrl("/media/sr/logos/main-logo.svg")}
              className="main-logo"
            />
          </div>
          <div>
            <img
              alt=""
              src={toAbsoluteUrl("/media/sr/icons/set_password.svg")}
              className="reset_password-logo"
            />
          </div>

          <div>
            <p className="reset-title">
              <FormattedMessage
                id="Auth_reset-title"
                defaultMessage="Create Password"
              />
            </p>
            <p className="reset-sub-title">
              <FormattedMessage
                id="Auth_reset-subtitle"
                defaultMessage="Enter New Password"
              />
            </p>
          </div>

          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            <div className="fv-plugins-icon-container sr-form-input">
              <TextField
                label={intl.formatMessage({
                  id: "Auth_input-password",
                  defaultMessage: "Password",
                })}
                outlined="true"
                className={`ipassowrd sr-input-outline2 ${filledInputClass(
                  "password"
                )}`}
                icon={
                  <div className="pre-icon">
                    <img
                      alt=""
                      src={toAbsoluteUrl("/media/sr/icons/password.svg")}
                      className="password-icon"
                    />
                  </div>
                }
                trailingIcon={
                  <div
                    className="post-icon"
                    onClick={() => toggelPasswordInput()}
                  >
                    <img
                      alt=""
                      id="show-hide-password"
                      src={
                        passwordShown
                          ? showPasswordIconUrl
                          : hidePasswordIconUrl
                      }
                      className="hide-password-icon"
                    />
                  </div>
                }
                onTrailingIconSelect={toggelPasswordInput}
                type={passwordShown ? "text" : "password"}
                name="password"
                {...formik.getFieldProps("password")}
              ></TextField>
              {formik.touched.password && formik.errors.password ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.password}</div>
                </div>
              ) : null}
            </div>

            <div className="fv-plugins-icon-container sr-form-input">
              <TextField
                label={intl.formatMessage({
                  id: "Auth_input-confirm-password",
                  defaultMessage: "Confirm Password",
                })}
                outlined="true"
                className={`ipassowrd sr-input-outline2 ${filledInputClass(
                  "password"
                )}`}
                icon={
                  <div
                    className="pre-icon"
                    onClick={() => toggelPasswordInput()}
                  >
                    <img
                      alt=""
                      src={toAbsoluteUrl(
                        "/media/sr/icons/confirm_password.svg"
                      )}
                      className="password-icon"
                    />
                  </div>
                }
                trailingIcon={
                  <div className="post-icon">
                    <img
                      alt=""
                      id="show-hide-password"
                      src={
                        confirmPasswordShown
                          ? showPasswordIconUrl
                          : hidePasswordIconUrl
                      }
                      className="hide-password-icon"
                    />
                  </div>
                }
                onTrailingIconSelect={toggelConfirmPasswordInput}
                type={confirmPasswordShown ? "text" : "password"}
                className2={` ${getInputClasses("password")}`}
                name="confirm_password"
                {...formik.getFieldProps("confirm_password")}
              ></TextField>
              {formik.touched.confirm_password &&
              formik.errors.confirm_password ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">
                    {formik.errors.confirm_password}
                  </div>
                </div>
              ) : null}
            </div>

            {formik.status && formik.status.isSuccess && (
              <div className="mb-2">
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.status.message}</div>
                </div>
              </div>
            )}

            {formik.status && !formik.status.isSuccess && (
              <div className="mb-2">
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.status.message}</div>
                </div>
              </div>
            )}

            <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_reset_submit"
                type="submit"
                disabled={formik.isSubmitting}
                className={`btn btn-block sbt-btn reset-password-btn mb-4`}
              >
                <span>
                  <FormattedMessage
                    id="Auth_reset-submit-button"
                    defaultMessage="Save & Sign In"
                  />
                </span>
                {loading && (
                  <span className="ml-3 spinner spinner-white"></span>
                )}
              </button>

              <Link
                to="/auth"
                className="w-100 link-clr text-center p-1 cacnel-lik"
                id="kt_login_forgot_cancel"
              >
                <b>
                  <FormattedMessage
                    id="Auth_general-cancel-button"
                    defaultMessage="Cancel"
                  />
                </b>
              </Link>

              <div className="powered-section text-center">
                <a
                  rel="noreferrer"
                  target="_blank"
                  href={APP_CONSTANT.POWERED_BY_LINK}
                >
                  <img
                    alt=""
                    src={toAbsoluteUrl("/media/sr/icons/powered-by.png")}
                    className="right-icon"
                  />
                </a>
              </div>
              <div className="site-footer mt-4 mb-8 text-center d-block d-lg-none">
                Copyright &#169; {APP_CONSTANT.COPYRIGHT_YEAR}, Knowlarity
                Communications Pvt. Ltd | Powered by Knowlarity | &nbsp;
                <a
                  href={APP_CONSTANT.SR_POLICY_LINK}
                  target="_blank"
                  className="link-clr"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>{" "}
                | &nbsp;
                <a
                  href={APP_CONSTANT.SR_TERMS_LINK}
                  target="_blank"
                  className="link-clr"
                  rel="noreferrer"
                >
                  Terms &amp; Conditions
                </a>
              </div>
            </div>
          </form>
        </div>
      )}
    </>
  );
}

export default injectIntl(connect(null, auth.actions)(ResetPassword));
